'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const components_navigation_LegacyButton_BaseButton = require('../../LegacyButton/BaseButton.cjs.js');

function NumberButton(_a) {
  var { selected, value, size = "small" } = _a, buttonProps = tslib_es6.__rest(_a, ["selected", "value", "size"]);
  return jsxRuntime.jsx(components_navigation_LegacyButton_BaseButton.BaseButton, Object.assign({ color: "number", isSquare: true, isSelected: selected, size }, buttonProps, { children: value }));
}

exports.NumberButton = NumberButton;
//# sourceMappingURL=NumberButton.cjs.js.map
